var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { PreLiveOutright } from "../../PreLiveOutright";
import { ViewAllBtn } from "../../ViewAllBtn";
import { getEventTitle } from "../../../../../helpers";
import { OutrightHeading } from "../../OutrightHeading/OutrightHeading";
var RenderPreliveOutright = /** @class */ (function (_super) {
    __extends(RenderPreliveOutright, _super);
    function RenderPreliveOutright() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderPreliveOutright.prototype.renderOutright = function () {
        return React.createElement(PreLiveOutright, { key: "prelive-outright-" + this.props.event.id, market: this.props.markets[0], numberOfSelectionsToShow: this.props.numberOfSelectionsToShow, betButtonHandler: this.props.handlers.betButton, hideLowOdds: this.props.hideLowOdds },
            React.createElement(ViewAllBtn, __assign({ key: "prelive-outright__view_all-" + this.props.event.id }, this.props.viewAllProps)));
    };
    RenderPreliveOutright.prototype.render = function () {
        if (!this.props.markets.length) {
            return React.createElement(React.Fragment, { key: "prelive-outright__empty-" + this.props.event.id });
        }
        var title = getEventTitle(this.props.event, this.props.markets[0], this.props.dict.EachWayTag);
        return this.props.showHeadingNames
            ? React.createElement(OutrightHeading, { key: "subheading-content-" + this.props.event.id, id: this.props.event.id, name: title }, this.renderOutright())
            : this.renderOutright();
    };
    return RenderPreliveOutright;
}(React.PureComponent));
export { RenderPreliveOutright };
//# sourceMappingURL=RenderPreliveOutright.js.map